import React from "react";
import Header from "../statics/Header";
import FooterLanding from "../statics/FooterLanding";

interface LayoutProps {
  children: React.ReactNode;
  showHeader?: boolean;
  showFooter?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, showHeader = true, showFooter = true }) => {
  return (
    <div style={styles.mainContainer}>
      {showHeader && <Header />}
      <main>{children}</main>
      {showFooter && <FooterLanding />}
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  mainContainer: {
    width: "100%",
    overflow: "hidden",
    fontFamily: "Outfit, sans-serif",
  },
};

export default Layout;
